import { createApp } from 'vue';
import Router from './router/index';
import './style.css';
import App from './App.vue';
import 'amfe-flexible';
import './utils/rem.ts';
import ElementPlus from 'element-plus';
import VueLazyload from 'vue-lazyload'
import 'element-plus/dist/index.css';
import "@/assets/css/common.css";
/*
import 'vue3-carousel/dist/carousel.css';
import 'animate.css';
// Import Swiper styles
import 'swiper/swiper-bundle.css';
// 重置样式 
import './assets/css/reset.min.css';
import "./assets/css/font.css";

import "./assets/css/pxToRem.scss"
import 'vue-fullpage.js/dist/style.css'
*/
import VueFullPage from 'vue-fullpage.js';
import 'virtual:svg-icons-register';
import 	SvgIcon from '@/components/svgIcon/index.vue'
// main.js
// 修改分页器文案
import zhCn from 'element-plus/es/locale/lang/zh-cn'
zhCn.el.pagination.goto = '前往'
zhCn.el.pagination.pageClassifier = ''

const app = createApp(App);
app.use(Router);
app.use(ElementPlus, {
    locale: zhCn 
});
app.component('svg-icon', SvgIcon);
app.mount('#app');
app.use(VueLazyload);
app.use(VueFullPage);
